import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _increment: {
      width: '4rem',
    },
    name: {
      name: 'รายละเอียด',
      width: '8rem',
    },
    status: {
      name: 'สถานะ',
      width: '6rem',
    },
    subJob: {
      name: 'SUB JOB',
      width: '6rem',
    },
    expense: {
      name: 'งบประมาณ',
      width: '6rem',
    },
    dueDate: {
      name: 'กำหนดส่ง',
      width: '8rem',
    },
  },

  sortable: [
    'name',
  ],
};
